import { MAX_PERIOD_START_DAY } from '@chukua/common';
import { Button, InputNumber } from 'antd';
import { useState } from 'react';

interface PeriodRuleCardProps {
  startDay: number;
  saving: boolean;
  onSave: (startDay: number) => Promise<void>;
}

/** The day of the month periods start on. A change applies to periods added afterwards; the ones already there keep their dates. */
export function PeriodRuleCard({ startDay, saving, onSave }: PeriodRuleCardProps) {
  const [draft, setDraft] = useState<number | null>(startDay);
  const isChanged = draft !== null && draft !== startDay;

  return (
    <section className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-line bg-surface p-4">
      <label htmlFor="period-start-day" className="text-sm font-medium text-fg">
        Periods start on day
      </label>
      <InputNumber id="period-start-day" min={1} max={MAX_PERIOD_START_DAY} precision={0} value={draft} onChange={setDraft} />
      <Button disabled={!isChanged} loading={saving} onClick={() => draft !== null && void onSave(draft)}>
        Save
      </Button>
      <p className="basis-full text-sm text-muted">Applies to periods added from now on. Periods already created keep their dates.</p>
    </section>
  );
}
